export default __webpack_public_path__ + "static/media/AUesome Map.6f049405.png";